import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetKCloudIntegrationRequestModel, GetKCloudIntegrationResponseModel } from "@/features/accounts/account-group/services/get-kcloud-integration-model";

export class GetKCloudIntegrationApi {
  /**
   * サービス連携情報取得
   */
  public getKCloudIntegration = async (
    param: GetKCloudIntegrationRequestModel
  ): Promise<GetKCloudIntegrationResponseModel> => {
    const path = `/api/cloud_linkinfo`;
    const res = await ApiClient.instance.get<GetKCloudIntegrationResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
